import styled from 'styled-components';

// The visible window, positioned in the clip's coordinate space by the plan's
// leftPx/widthPx (via style — they move with every scroll and zoom).
export const StyledWindow = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
`;
